"use client"

import { FONT_VARIANT } from "@/lib/constants";
import Image from "next/image";
import { useInView } from "@/hooks/use-in-view";

export default function About() {
    const [imageRef, imageInView] = useInView({ threshold: 0.2 });
    const [textRef, textInView] = useInView({ threshold: 0.3 });

    return (
        <section id="about" className="py-32 md:py-40 text-white relative overflow-hidden" aria-label="Über Bachmann Catering" style={{ paddingTop: '16rem', paddingBottom: '16rem' }}>
            <div className="container relative">
                <div className="relative h-[700px] md:h-[800px]">
                    {/* Large background image */}
                    <div
                        ref={imageRef}
                        className={`absolute inset-0 w-full h-full animate-on-scroll ${imageInView ? 'animate-fade-in-right' : ''}`}
                    >
                        <Image
                            src="/images/16.jpg"
                            alt="Barbara Bachmann und ihr professionelles Catering-Team bei der Vorbereitung eines eleganten Events"
                            fill
                            className="object-cover transition-transform duration-700 group-hover:scale-105"
                            priority
                        />
                        {/* Dark overlay for better text readability */}
                        <div className="absolute inset-0 bg-black/30"></div>
                    </div>

                    {/* Overlapping text content */}
                    <div
                        ref={textRef}
                        className={`group z-50 rounded-sm absolute top-1/2 md:left-16 lg:left-24 transform -translate-y-1/2 max-w-lg lg:max-w-xl border border-white/10 bg-white/5 backdrop-blur-md shadow-xl p-8 md:p-10 animate-on-scroll ${textInView ? 'animate-fade-in-left delay-300' : ''}`}
                    >
                        <div className="pointer-events-none absolute inset-0 z-0 bg-gradient-to-br from-[#a19b92]/20 via-[#222]/10 to-transparent opacity-60 group-hover:opacity-90 transition-opacity duration-300" />
                        <div className="relative z-10">
                            <h2 className={`absolute -top-1/3 md:-top-2/3 -left-7 md:left-auto leading-none uppercase font-adobe text-[3rem] md:text-[5rem] mb-6 italic`}>Authentisch. Kreativ. Mit Anspruch.</h2>
                            <div className={`mt-10w-20 h-px bg-[#a19b92] my-6 animate-on-scroll ${textInView ? 'animate-slide-up-line delay-400' : ''}`}></div>
                            <p className={`text-[#c4bfb7] mb-6 text-sm md:text-base leading-relaxed animate-on-scroll ${textInView ? 'animate-fade-in-up delay-500' : ''}`}>
                                Bachmann ist ein familiengeführtes Unternehmen – gegründet aus Leidenschaft für gutes Essen und ehrliche Gastfreundschaft. Seit über 30 Jahren steht Barbara Bachmann für Qualität, Verlässlichkeit und kulinarische Handschrift.
                            </p>
                            <p className={`text-[#c4bfb7] mb-6 text-sm md:text-base leading-relaxed animate-on-scroll ${textInView ? 'animate-fade-in-up delay-600' : ''}`}>
                                Mit ihrer Erfahrung, ihrem Gespür für Menschen und ihrer Liebe zum Detail führt sie das Unternehmen – klar, persönlich und mit einer modernen Perspektive auf Catering und Eventkultur.
                            </p>
                            <div className={`border-l-2 border-white/30 pl-6 mt-8 animate-on-scroll ${textInView ? 'animate-fade-in-left delay-700' : ''}`}>
                                <h3 className="text-white font-medium mb-4">Unser Anspruch:</h3>
                                <ul className="space-y-3">
                                    <li className={`flex items-start animate-on-scroll ${textInView ? 'animate-fade-in-up delay-800' : ''}`}>
                                        <div className="w-1.5 h-1.5 bg-white mt-2 mr-3 flex-shrink-0 rounded-full"></div>
                                        <span className="text-[#a19b92] text-sm md:text-base">Kulinarik mit Haltung</span>
                                    </li>
                                    <li className={`flex items-start animate-on-scroll ${textInView ? 'animate-fade-in-up delay-900' : ''}`}>
                                        <div className="w-1.5 h-1.5 bg-white mt-2 mr-3 flex-shrink-0 rounded-full   "></div>
                                        <span className="text-[#a19b92] text-sm md:text-base">Umsetzung mit Charakter</span>
                                    </li>
                                    <li className={`flex items-start animate-on-scroll ${textInView ? 'animate-fade-in-up delay-1000' : ''}`}>
                                        <div className="w-1.5 h-1.5 bg-white mt-2 mr-3 flex-shrink-0 rounded-full"></div>
                                        <span className="text-[#a19b92] text-sm md:text-base">Erlebnisse, die im Kopf bleiben</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Spacer to prevent overlap with next section */}
            <div className="h-64 md:h-80"></div>
        </section>
    );
}
